
<div class="relative-container">
  <scroll-area allow-horizontal class="horizontal-table">
    <matrix
      allow-horizontal
      :has-data="attachments.length > 0">
      <template #table-header>
        <t-column
          is-heading
          v-for="header in headers"
          :key="header">
          {{ header }}
        </t-column>
      </template>
      <template #table-body>
        <detail-view-file-property-table-row
          v-for="attachment in attachments" :attachment="attachment" :key="attachment.id">
        </detail-view-file-property-table-row>
      </template>
    </matrix>
  </scroll-area>
</div>
